// Story 8.10 (ADO-2019): the tinted depot tile beside a depot name (the 8.10 Figma
// exports: a basket for Ambient, a thermometer for Chill, a wine glass for Alcohol, each
// a 20px icon in the depot's dark tone; any other depot a storefront). Decorative: the
// depot name is always next to it.
import { Icon } from '../../design-system';
import { depotMarkFor } from './hhtFormat';
import styles from './HhtOrders.module.css';

export function DepotMark({ depotCode }: { readonly depotCode: string }) {
  const { icon, tone } = depotMarkFor(depotCode);
  return (
    <span className={styles.depotMark} data-tone={tone} aria-hidden>
      <Icon name={icon} size={20} />
    </span>
  );
}
